@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.site.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.site.resources/"

@delegate:ResourceContentHash(1_671_692_659)
internal val Res.string.site_access_title: StringResource by lazy {
      StringResource("string:site_access_title", "site_access_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 33),
      ))
    }

@delegate:ResourceContentHash(1_315_574_865)
internal val Res.string.site_added_by: StringResource by lazy {
      StringResource("string:site_added_by", "site_added_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127, 69),
      ))
    }

@delegate:ResourceContentHash(1_582_330_791)
internal val Res.string.site_added_by_just_now: StringResource by lazy {
      StringResource("string:site_added_by_just_now", "site_added_by_just_now", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44, 82),
      ))
    }

@delegate:ResourceContentHash(1_763_970_560)
internal val Res.string.site_count_few: StringResource by lazy {
      StringResource("string:site_count_few", "site_count_few", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197, 30),
      ))
    }

@delegate:ResourceContentHash(2_397_902)
internal val Res.string.site_count_many: StringResource by lazy {
      StringResource("string:site_count_many", "site_count_many", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228, 27),
      ))
    }

@delegate:ResourceContentHash(2_373_700)
internal val Res.string.site_count_one: StringResource by lazy {
      StringResource("string:site_count_one", "site_count_one", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256, 26),
      ))
    }

@delegate:ResourceContentHash(137_972_699)
internal val Res.string.site_count_some: StringResource by lazy {
      StringResource("string:site_count_some", "site_count_some", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283, 35),
      ))
    }

@delegate:ResourceContentHash(-1_654_442_654)
internal val Res.string.site_create_access_ask: StringResource by lazy {
      StringResource("string:site_create_access_ask", "site_create_access_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 411, 50),
      ))
    }

@delegate:ResourceContentHash(645_083_995)
internal val Res.string.site_create_access_ask_hint: StringResource by lazy {
      StringResource("string:site_create_access_ask_hint", "site_create_access_ask_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319, 91),
      ))
    }

@delegate:ResourceContentHash(-1_430_974_965)
internal val Res.string.site_create_access_hint: StringResource by lazy {
      StringResource("string:site_create_access_hint", "site_create_access_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 462, 67),
      ))
    }

@delegate:ResourceContentHash(429_502_426)
internal val Res.string.site_create_access_open: StringResource by lazy {
      StringResource("string:site_create_access_open", "site_create_access_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 623, 67),
      ))
    }

@delegate:ResourceContentHash(-600_695_057)
internal val Res.string.site_create_access_open_hint: StringResource by lazy {
      StringResource("string:site_create_access_open_hint", "site_create_access_open_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 530, 92),
      ))
    }

@delegate:ResourceContentHash(876_190_334)
internal val Res.string.site_create_access_title: StringResource by lazy {
      StringResource("string:site_create_access_title", "site_create_access_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 691, 64),
      ))
    }

@delegate:ResourceContentHash(-1_721_916_154)
internal val Res.string.site_create_back: StringResource by lazy {
      StringResource("string:site_create_back", "site_create_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 756, 32),
      ))
    }

@delegate:ResourceContentHash(-1_438_906_913)
internal val Res.string.site_create_exit_continue: StringResource by lazy {
      StringResource("string:site_create_exit_continue", "site_create_exit_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 789, 45),
      ))
    }

@delegate:ResourceContentHash(-1_309_018_753)
internal val Res.string.site_create_exit_quit: StringResource by lazy {
      StringResource("string:site_create_exit_quit", "site_create_exit_quit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 835, 41),
      ))
    }

@delegate:ResourceContentHash(1_471_993_238)
internal val Res.string.site_create_exit_title: StringResource by lazy {
      StringResource("string:site_create_exit_title", "site_create_exit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 877, 70),
      ))
    }

@delegate:ResourceContentHash(-1_845_613_883)
internal val Res.string.site_create_header: StringResource by lazy {
      StringResource("string:site_create_header", "site_create_header", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 948, 62),
      ))
    }

@delegate:ResourceContentHash(-1_845_662_389)
internal val Res.string.site_create_home: StringResource by lazy {
      StringResource("string:site_create_home", "site_create_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1145, 44),
      ))
    }

@delegate:ResourceContentHash(-906_251_556)
internal val Res.string.site_create_home_hint: StringResource by lazy {
      StringResource("string:site_create_home_hint", "site_create_home_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1011, 133),
      ))
    }

@delegate:ResourceContentHash(1_660_652_284)
internal val Res.string.site_create_manager_label: StringResource by lazy {
      StringResource("string:site_create_manager_label", "site_create_manager_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1190, 73),
      ))
    }

@delegate:ResourceContentHash(-721_193_286)
internal val Res.string.site_create_name_hint: StringResource by lazy {
      StringResource("string:site_create_name_hint", "site_create_name_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1264, 89),
      ))
    }

@delegate:ResourceContentHash(367_752_384)
internal val Res.string.site_create_name_label: StringResource by lazy {
      StringResource("string:site_create_name_label", "site_create_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1354, 62),
      ))
    }

@delegate:ResourceContentHash(540_538_588)
internal val Res.string.site_create_plantings_hint: StringResource by lazy {
      StringResource("string:site_create_plantings_hint", "site_create_plantings_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1417, 142),
      ))
    }

@delegate:ResourceContentHash(1_822_757_294)
internal val Res.string.site_create_plantings_title: StringResource by lazy {
      StringResource("string:site_create_plantings_title", "site_create_plantings_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1560, 67),
      ))
    }

@delegate:ResourceContentHash(1_420_507_852)
internal val Res.string.site_create_retry: StringResource by lazy {
      StringResource("string:site_create_retry", "site_create_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1628, 41),
      ))
    }

@delegate:ResourceContentHash(-62_478_434)
internal val Res.string.site_create_step_place: StringResource by lazy {
      StringResource("string:site_create_step_place", "site_create_step_place", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1670, 38),
      ))
    }

@delegate:ResourceContentHash(-1_004_755_433)
internal val Res.string.site_create_step_site: StringResource by lazy {
      StringResource("string:site_create_step_site", "site_create_step_site", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1709, 41),
      ))
    }

@delegate:ResourceContentHash(-1_887_417_378)
internal val Res.string.site_create_step_state: StringResource by lazy {
      StringResource("string:site_create_step_state", "site_create_step_state", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1751, 62),
      ))
    }

@delegate:ResourceContentHash(1_837_376_337)
internal val Res.string.site_create_submit: StringResource by lazy {
      StringResource("string:site_create_submit", "site_create_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1814, 46),
      ))
    }

@delegate:ResourceContentHash(516_020_218)
internal val Res.string.site_delete: StringResource by lazy {
      StringResource("string:site_delete", "site_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2079, 43),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.site_delete_cancel: StringResource by lazy {
      StringResource("string:site_delete_cancel", "site_delete_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1861, 38),
      ))
    }

@delegate:ResourceContentHash(-981_801_054)
internal val Res.string.site_delete_confirm: StringResource by lazy {
      StringResource("string:site_delete_confirm", "site_delete_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1900, 39),
      ))
    }

@delegate:ResourceContentHash(461_948_475)
internal val Res.string.site_delete_text: StringResource by lazy {
      StringResource("string:site_delete_text", "site_delete_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1940, 84),
      ))
    }

@delegate:ResourceContentHash(-1_137_227_221)
internal val Res.string.site_delete_title: StringResource by lazy {
      StringResource("string:site_delete_title", "site_delete_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2025, 53),
      ))
    }

@delegate:ResourceContentHash(-2_144_787_840)
internal val Res.string.site_detail_kind: StringResource by lazy {
      StringResource("string:site_detail_kind", "site_detail_kind", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2123, 32),
      ))
    }

@delegate:ResourceContentHash(-2_144_787_840)
internal val Res.string.site_detail_title: StringResource by lazy {
      StringResource("string:site_detail_title", "site_detail_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2156, 33),
      ))
    }

@delegate:ResourceContentHash(-44_780_453)
internal val Res.string.site_directions: StringResource by lazy {
      StringResource("string:site_directions", "site_directions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2190, 39),
      ))
    }

@delegate:ResourceContentHash(-1_451_841_500)
internal val Res.string.site_favorite_add: StringResource by lazy {
      StringResource("string:site_favorite_add", "site_favorite_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2230, 53),
      ))
    }

@delegate:ResourceContentHash(234_662_492)
internal val Res.string.site_favorite_remove: StringResource by lazy {
      StringResource("string:site_favorite_remove", "site_favorite_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2284, 56),
      ))
    }

@delegate:ResourceContentHash(1_946_803_229)
internal val Res.string.site_harvests_at_home: StringResource by lazy {
      StringResource("string:site_harvests_at_home", "site_harvests_at_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2341, 41),
      ))
    }

@delegate:ResourceContentHash(671_477_476)
internal val Res.string.site_harvests_empty: StringResource by lazy {
      StringResource("string:site_harvests_empty", "site_harvests_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2383, 79),
      ))
    }

@delegate:ResourceContentHash(-426_418_463)
internal val Res.string.site_harvests_participants: StringResource by lazy {
      StringResource("string:site_harvests_participants", "site_harvests_participants", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2541, 62),
      ))
    }

@delegate:ResourceContentHash(-995_933_056)
internal val Res.string.site_harvests_participants_of: StringResource by lazy {
      StringResource("string:site_harvests_participants_of", "site_harvests_participants_of", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2463, 77),
      ))
    }

@delegate:ResourceContentHash(-1_624_967_384)
internal val Res.string.site_harvests_start: StringResource by lazy {
      StringResource("string:site_harvests_start", "site_harvests_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2604, 55),
      ))
    }

@delegate:ResourceContentHash(1_919_429_438)
internal val Res.string.site_harvests_title: StringResource by lazy {
      StringResource("string:site_harvests_title", "site_harvests_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2660, 51),
      ))
    }

@delegate:ResourceContentHash(28_107_020)
internal val Res.string.site_imported_angers: StringResource by lazy {
      StringResource("string:site_imported_angers", "site_imported_angers", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2853, 68),
      ))
    }

@delegate:ResourceContentHash(-111_959_840)
internal val Res.string.site_imported_angers_license: StringResource by lazy {
      StringResource("string:site_imported_angers_license", "site_imported_angers_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2712, 140),
      ))
    }

@delegate:ResourceContentHash(1_151_392_581)
internal val Res.string.site_imported_cergy: StringResource by lazy {
      StringResource("string:site_imported_cergy", "site_imported_cergy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3026, 67),
      ))
    }

@delegate:ResourceContentHash(1_001_355_748)
internal val Res.string.site_imported_cergy_license: StringResource by lazy {
      StringResource("string:site_imported_cergy_license", "site_imported_cergy_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2922, 103),
      ))
    }

@delegate:ResourceContentHash(2_033_142_681)
internal val Res.string.site_imported_la_rochelle: StringResource by lazy {
      StringResource("string:site_imported_la_rochelle", "site_imported_la_rochelle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3244, 93),
      ))
    }

@delegate:ResourceContentHash(377_248_494)
internal val Res.string.site_imported_la_rochelle_license: StringResource by lazy {
      StringResource("string:site_imported_la_rochelle_license", "site_imported_la_rochelle_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3094, 149),
      ))
    }

@delegate:ResourceContentHash(-2_043_647_836)
internal val Res.string.site_imported_osm: StringResource by lazy {
      StringResource("string:site_imported_osm", "site_imported_osm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3452, 57),
      ))
    }

@delegate:ResourceContentHash(-152_592_787)
internal val Res.string.site_imported_osm_license: StringResource by lazy {
      StringResource("string:site_imported_osm_license", "site_imported_osm_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3338, 113),
      ))
    }

@delegate:ResourceContentHash(-1_900_671_765)
internal val Res.string.site_lookalike: StringResource by lazy {
      StringResource("string:site_lookalike", "site_lookalike", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3510, 54),
      ))
    }

@delegate:ResourceContentHash(-1_721_916_154)
internal val Res.string.site_not_found_back: StringResource by lazy {
      StringResource("string:site_not_found_back", "site_not_found_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3565, 35),
      ))
    }

@delegate:ResourceContentHash(1_489_245_451)
internal val Res.string.site_not_found_message: StringResource by lazy {
      StringResource("string:site_not_found_message", "site_not_found_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3601, 110),
      ))
    }

@delegate:ResourceContentHash(19_838_396)
internal val Res.string.site_not_found_title: StringResource by lazy {
      StringResource("string:site_not_found_title", "site_not_found_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3712, 84),
      ))
    }

@delegate:ResourceContentHash(-1_845_662_389)
internal val Res.string.site_owner_claim: StringResource by lazy {
      StringResource("string:site_owner_claim", "site_owner_claim", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4082, 44),
      ))
    }

@delegate:ResourceContentHash(-917_619_766)
internal val Res.string.site_owner_claim_text: StringResource by lazy {
      StringResource("string:site_owner_claim_text", "site_owner_claim_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3797, 181),
      ))
    }

@delegate:ResourceContentHash(-905_342_998)
internal val Res.string.site_owner_claimed: StringResource by lazy {
      StringResource("string:site_owner_claimed", "site_owner_claimed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3979, 102),
      ))
    }

@delegate:ResourceContentHash(-1_654_442_654)
internal val Res.string.site_owner_rule_ask: StringResource by lazy {
      StringResource("string:site_owner_rule_ask", "site_owner_rule_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4127, 47),
      ))
    }

@delegate:ResourceContentHash(-1_275_322_874)
internal val Res.string.site_owner_rule_changed: StringResource by lazy {
      StringResource("string:site_owner_rule_changed", "site_owner_rule_changed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4175, 71),
      ))
    }

@delegate:ResourceContentHash(670_751_943)
internal val Res.string.site_owner_rule_hint: StringResource by lazy {
      StringResource("string:site_owner_rule_hint", "site_owner_rule_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4247, 84),
      ))
    }

@delegate:ResourceContentHash(1_926_811_893)
internal val Res.string.site_owner_rule_open: StringResource by lazy {
      StringResource("string:site_owner_rule_open", "site_owner_rule_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4332, 44),
      ))
    }

@delegate:ResourceContentHash(-1_238_990_613)
internal val Res.string.site_owner_rule_private: StringResource by lazy {
      StringResource("string:site_owner_rule_private", "site_owner_rule_private", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4377, 51),
      ))
    }

@delegate:ResourceContentHash(931_589_955)
internal val Res.string.site_owner_rule_title: StringResource by lazy {
      StringResource("string:site_owner_rule_title", "site_owner_rule_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4429, 49),
      ))
    }

@delegate:ResourceContentHash(2_071_890_728)
internal val Res.string.site_owner_unclaim: StringResource by lazy {
      StringResource("string:site_owner_unclaim", "site_owner_unclaim", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5208, 66),
      ))
    }

@delegate:ResourceContentHash(-818_230_346)
internal val Res.string.site_owner_unclaim_confirm: StringResource by lazy {
      StringResource("string:site_owner_unclaim_confirm", "site_owner_unclaim_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4479, 50),
      ))
    }

@delegate:ResourceContentHash(-1_613_832_205)
internal val Res.string.site_owner_unclaim_hint: StringResource by lazy {
      StringResource("string:site_owner_unclaim_hint", "site_owner_unclaim_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4530, 243),
      ))
    }

@delegate:ResourceContentHash(342_613_473)
internal val Res.string.site_owner_unclaim_text: StringResource by lazy {
      StringResource("string:site_owner_unclaim_text", "site_owner_unclaim_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4774, 235),
      ))
    }

@delegate:ResourceContentHash(-316_478_290)
internal val Res.string.site_owner_unclaim_title: StringResource by lazy {
      StringResource("string:site_owner_unclaim_title", "site_owner_unclaim_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5010, 72),
      ))
    }

@delegate:ResourceContentHash(-101_378_826)
internal val Res.string.site_owner_unclaimed: StringResource by lazy {
      StringResource("string:site_owner_unclaimed", "site_owner_unclaimed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5083, 124),
      ))
    }

@delegate:ResourceContentHash(1_330_367_496)
internal val Res.string.site_planting_add: StringResource by lazy {
      StringResource("string:site_planting_add", "site_planting_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5392, 57),
      ))
    }

@delegate:ResourceContentHash(-391_061_656)
internal val Res.string.site_planting_add_submit: StringResource by lazy {
      StringResource("string:site_planting_add_submit", "site_planting_add_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5275, 56),
      ))
    }

@delegate:ResourceContentHash(1_320_319_245)
internal val Res.string.site_planting_added: StringResource by lazy {
      StringResource("string:site_planting_added", "site_planting_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5332, 59),
      ))
    }

@delegate:ResourceContentHash(1_980_916_626)
internal val Res.string.site_planting_count_group: StringResource by lazy {
      StringResource("string:site_planting_count_group", "site_planting_count_group", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5450, 53),
      ))
    }

@delegate:ResourceContentHash(-524_662_897)
internal val Res.string.site_planting_remove: StringResource by lazy {
      StringResource("string:site_planting_remove", "site_planting_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5504, 40),
      ))
    }

@delegate:ResourceContentHash(2_050_336_334)
internal val Res.string.site_plantings_hint: StringResource by lazy {
      StringResource("string:site_plantings_hint", "site_plantings_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5545, 83),
      ))
    }

@delegate:ResourceContentHash(-1_758_009_337)
internal val Res.string.site_plantings_title: StringResource by lazy {
      StringResource("string:site_plantings_title", "site_plantings_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5629, 48),
      ))
    }

@delegate:ResourceContentHash(219_325_699)
internal val Res.string.site_private_locked_notified: StringResource by lazy {
      StringResource("string:site_private_locked_notified", "site_private_locked_notified", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5678, 52),
      ))
    }

@delegate:ResourceContentHash(1_847_945_884)
internal val Res.string.site_private_locked_notify: StringResource by lazy {
      StringResource("string:site_private_locked_notify", "site_private_locked_notify", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5731, 54),
      ))
    }

@delegate:ResourceContentHash(-1_364_627_776)
internal val Res.string.site_private_locked_text: StringResource by lazy {
      StringResource("string:site_private_locked_text", "site_private_locked_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5786, 216),
      ))
    }

@delegate:ResourceContentHash(-779_636_784)
internal val Res.string.site_report: StringResource by lazy {
      StringResource("string:site_report", "site_report", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6475, 43),
      ))
    }

@delegate:ResourceContentHash(1_935_300_312)
internal val Res.string.site_report_details: StringResource by lazy {
      StringResource("string:site_report_details", "site_report_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6003, 63),
      ))
    }

@delegate:ResourceContentHash(-1_912_562_639)
internal val Res.string.site_report_gone: StringResource by lazy {
      StringResource("string:site_report_gone", "site_report_gone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6067, 52),
      ))
    }

@delegate:ResourceContentHash(688_504_667)
internal val Res.string.site_report_other: StringResource by lazy {
      StringResource("string:site_report_other", "site_report_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6120, 41),
      ))
    }

@delegate:ResourceContentHash(-1_515_281_033)
internal val Res.string.site_report_send: StringResource by lazy {
      StringResource("string:site_report_send", "site_report_send", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6162, 36),
      ))
    }

@delegate:ResourceContentHash(-1_653_615_472)
internal val Res.string.site_report_sent: StringResource by lazy {
      StringResource("string:site_report_sent", "site_report_sent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6199, 60),
      ))
    }

@delegate:ResourceContentHash(-580_928_003)
internal val Res.string.site_report_wrong_access: StringResource by lazy {
      StringResource("string:site_report_wrong_access", "site_report_wrong_access", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6260, 72),
      ))
    }

@delegate:ResourceContentHash(-434_199_617)
internal val Res.string.site_report_wrong_owner: StringResource by lazy {
      StringResource("string:site_report_wrong_owner", "site_report_wrong_owner", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6333, 99),
      ))
    }

@delegate:ResourceContentHash(439_322_686)
internal val Res.string.site_reported: StringResource by lazy {
      StringResource("string:site_reported", "site_reported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6433, 41),
      ))
    }

@delegate:ResourceContentHash(-1_654_442_654)
internal val Res.string.site_rule_ask: StringResource by lazy {
      StringResource("string:site_rule_ask", "site_rule_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6519, 41),
      ))
    }

@delegate:ResourceContentHash(191_970_735)
internal val Res.string.site_rule_notice_ask: StringResource by lazy {
      StringResource("string:site_rule_notice_ask", "site_rule_notice_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6630, 64),
      ))
    }

@delegate:ResourceContentHash(-1_185_503_552)
internal val Res.string.site_rule_notice_ask_manager: StringResource by lazy {
      StringResource("string:site_rule_notice_ask_manager", "site_rule_notice_ask_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6561, 68),
      ))
    }

@delegate:ResourceContentHash(-1_832_441_085)
internal val Res.string.site_rule_notice_open: StringResource by lazy {
      StringResource("string:site_rule_notice_open", "site_rule_notice_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6695, 133),
      ))
    }

@delegate:ResourceContentHash(-1_978_792_436)
internal val Res.string.site_rule_notice_private: StringResource by lazy {
      StringResource("string:site_rule_notice_private", "site_rule_notice_private", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6829, 156),
      ))
    }

@delegate:ResourceContentHash(1_926_811_893)
internal val Res.string.site_rule_open: StringResource by lazy {
      StringResource("string:site_rule_open", "site_rule_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6986, 38),
      ))
    }

@delegate:ResourceContentHash(512_460_700)
internal val Res.string.site_rule_private: StringResource by lazy {
      StringResource("string:site_rule_private", "site_rule_private", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7025, 57),
      ))
    }

@delegate:ResourceContentHash(-935_715_221)
internal val Res.string.site_species_search: StringResource by lazy {
      StringResource("string:site_species_search", "site_species_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7145, 55),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("site_access_title", Res.string.site_access_title)
  map.put("site_added_by", Res.string.site_added_by)
  map.put("site_added_by_just_now", Res.string.site_added_by_just_now)
  map.put("site_count_few", Res.string.site_count_few)
  map.put("site_count_many", Res.string.site_count_many)
  map.put("site_count_one", Res.string.site_count_one)
  map.put("site_count_some", Res.string.site_count_some)
  map.put("site_create_access_ask", Res.string.site_create_access_ask)
  map.put("site_create_access_ask_hint", Res.string.site_create_access_ask_hint)
  map.put("site_create_access_hint", Res.string.site_create_access_hint)
  map.put("site_create_access_open", Res.string.site_create_access_open)
  map.put("site_create_access_open_hint", Res.string.site_create_access_open_hint)
  map.put("site_create_access_title", Res.string.site_create_access_title)
  map.put("site_create_back", Res.string.site_create_back)
  map.put("site_create_exit_continue", Res.string.site_create_exit_continue)
  map.put("site_create_exit_quit", Res.string.site_create_exit_quit)
  map.put("site_create_exit_title", Res.string.site_create_exit_title)
  map.put("site_create_header", Res.string.site_create_header)
  map.put("site_create_home", Res.string.site_create_home)
  map.put("site_create_home_hint", Res.string.site_create_home_hint)
  map.put("site_create_manager_label", Res.string.site_create_manager_label)
  map.put("site_create_name_hint", Res.string.site_create_name_hint)
  map.put("site_create_name_label", Res.string.site_create_name_label)
  map.put("site_create_plantings_hint", Res.string.site_create_plantings_hint)
  map.put("site_create_plantings_title", Res.string.site_create_plantings_title)
  map.put("site_create_retry", Res.string.site_create_retry)
  map.put("site_create_step_place", Res.string.site_create_step_place)
  map.put("site_create_step_site", Res.string.site_create_step_site)
  map.put("site_create_step_state", Res.string.site_create_step_state)
  map.put("site_create_submit", Res.string.site_create_submit)
  map.put("site_delete", Res.string.site_delete)
  map.put("site_delete_cancel", Res.string.site_delete_cancel)
  map.put("site_delete_confirm", Res.string.site_delete_confirm)
  map.put("site_delete_text", Res.string.site_delete_text)
  map.put("site_delete_title", Res.string.site_delete_title)
  map.put("site_detail_kind", Res.string.site_detail_kind)
  map.put("site_detail_title", Res.string.site_detail_title)
  map.put("site_directions", Res.string.site_directions)
  map.put("site_favorite_add", Res.string.site_favorite_add)
  map.put("site_favorite_remove", Res.string.site_favorite_remove)
  map.put("site_harvests_at_home", Res.string.site_harvests_at_home)
  map.put("site_harvests_empty", Res.string.site_harvests_empty)
  map.put("site_harvests_participants", Res.string.site_harvests_participants)
  map.put("site_harvests_participants_of", Res.string.site_harvests_participants_of)
  map.put("site_harvests_start", Res.string.site_harvests_start)
  map.put("site_harvests_title", Res.string.site_harvests_title)
  map.put("site_imported_angers", Res.string.site_imported_angers)
  map.put("site_imported_angers_license", Res.string.site_imported_angers_license)
  map.put("site_imported_cergy", Res.string.site_imported_cergy)
  map.put("site_imported_cergy_license", Res.string.site_imported_cergy_license)
  map.put("site_imported_la_rochelle", Res.string.site_imported_la_rochelle)
  map.put("site_imported_la_rochelle_license", Res.string.site_imported_la_rochelle_license)
  map.put("site_imported_osm", Res.string.site_imported_osm)
  map.put("site_imported_osm_license", Res.string.site_imported_osm_license)
  map.put("site_lookalike", Res.string.site_lookalike)
  map.put("site_not_found_back", Res.string.site_not_found_back)
  map.put("site_not_found_message", Res.string.site_not_found_message)
  map.put("site_not_found_title", Res.string.site_not_found_title)
  map.put("site_owner_claim", Res.string.site_owner_claim)
  map.put("site_owner_claim_text", Res.string.site_owner_claim_text)
  map.put("site_owner_claimed", Res.string.site_owner_claimed)
  map.put("site_owner_rule_ask", Res.string.site_owner_rule_ask)
  map.put("site_owner_rule_changed", Res.string.site_owner_rule_changed)
  map.put("site_owner_rule_hint", Res.string.site_owner_rule_hint)
  map.put("site_owner_rule_open", Res.string.site_owner_rule_open)
  map.put("site_owner_rule_private", Res.string.site_owner_rule_private)
  map.put("site_owner_rule_title", Res.string.site_owner_rule_title)
  map.put("site_owner_unclaim", Res.string.site_owner_unclaim)
  map.put("site_owner_unclaim_confirm", Res.string.site_owner_unclaim_confirm)
  map.put("site_owner_unclaim_hint", Res.string.site_owner_unclaim_hint)
  map.put("site_owner_unclaim_text", Res.string.site_owner_unclaim_text)
  map.put("site_owner_unclaim_title", Res.string.site_owner_unclaim_title)
  map.put("site_owner_unclaimed", Res.string.site_owner_unclaimed)
  map.put("site_planting_add", Res.string.site_planting_add)
  map.put("site_planting_add_submit", Res.string.site_planting_add_submit)
  map.put("site_planting_added", Res.string.site_planting_added)
  map.put("site_planting_count_group", Res.string.site_planting_count_group)
  map.put("site_planting_remove", Res.string.site_planting_remove)
  map.put("site_plantings_hint", Res.string.site_plantings_hint)
  map.put("site_plantings_title", Res.string.site_plantings_title)
  map.put("site_private_locked_notified", Res.string.site_private_locked_notified)
  map.put("site_private_locked_notify", Res.string.site_private_locked_notify)
  map.put("site_private_locked_text", Res.string.site_private_locked_text)
  map.put("site_report", Res.string.site_report)
  map.put("site_report_details", Res.string.site_report_details)
  map.put("site_report_gone", Res.string.site_report_gone)
  map.put("site_report_other", Res.string.site_report_other)
  map.put("site_report_send", Res.string.site_report_send)
  map.put("site_report_sent", Res.string.site_report_sent)
  map.put("site_report_wrong_access", Res.string.site_report_wrong_access)
  map.put("site_report_wrong_owner", Res.string.site_report_wrong_owner)
  map.put("site_reported", Res.string.site_reported)
  map.put("site_rule_ask", Res.string.site_rule_ask)
  map.put("site_rule_notice_ask", Res.string.site_rule_notice_ask)
  map.put("site_rule_notice_ask_manager", Res.string.site_rule_notice_ask_manager)
  map.put("site_rule_notice_open", Res.string.site_rule_notice_open)
  map.put("site_rule_notice_private", Res.string.site_rule_notice_private)
  map.put("site_rule_open", Res.string.site_rule_open)
  map.put("site_rule_private", Res.string.site_rule_private)
  map.put("site_species_search", Res.string.site_species_search)
}
